"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ghost = exports.basic = exports.select = exports.icon = exports.menuItem = void 0;

var _react = require("@emotion/react");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", ";\n\n  > .Mui-disabled {\n    color: ", ";\n  }\n\n  > .Mui-disabled > .MuiSvgIcon-root {\n    display: none;\n  }\n\n  & > .MuiInputBase-root {\n    background-color: ", ";\n    & .MuiSelect-root {\n      &.Mui-disabled {\n        padding: 7px 12px 7px 12px;\n      }\n    }\n    & > .MuiOutlinedInput-notchedOutline {\n      border: none;\n    }\n    &.Mui-focused {\n      & > .MuiOutlinedInput-notchedOutline {\n        border: 1px solid\n          ", ";\n        box-shadow: 0 0 0 4px\n          ", "26;\n      }\n    }\n    &:hover {\n      background-color: ", ";\n      &.Mui-disabled {\n        background-color: ", ";\n      }\n    }\n    & > .MuiSelect-icon {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", ";\n\n  > .Mui-disabled::before {\n    border: none !important;\n  }\n\n  > .Mui-disabled {\n    opacity: 0.4;\n  }\n\n  & > .MuiInputBase-root {\n    background-color: ", ";\n\n    & > .MuiOutlinedInput-notchedOutline {\n      border: 1px solid\n        ", ";\n    }\n    &.Mui-focused {\n      & > .MuiOutlinedInput-notchedOutline {\n        border: 1px solid\n          ", ";\n        box-shadow: 0 0 0 4px\n          ", "26;\n      }\n    }\n    &:hover {\n      & > .MuiOutlinedInput-notchedOutline {\n        border: 1px solid\n          ", ";\n      }\n    }\n    &.Mui-disabled {\n      &:hover {\n        & > .MuiOutlinedInput-notchedOutline {\n          border: 1px solid ", ";\n        }\n      }\n    }\n    & > .MuiSelect-icon {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n\n  & > .MuiInputBase-root {\n    color: ", ";\n    min-height: 36px;\n    & > .MuiSelect-root {\n      min-height: unset;\n      padding: 7px 36px 7px 12px;\n\n      font-size: ", ";\n      line-height: ", ";\n      letter-spacing: ", ";\n\n      & > svg {\n        display: none;\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n  width: 24px;\n  height: 24px;\n  cursor: inherit;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  justify-content: space-between;\n  padding: 10px 16px;\n  min-height: auto;\n  height: 40px;\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  & > svg {\n    visibility: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var menuItem = function menuItem(isSelectedItem) {
  return function (theme) {
    return (0, _react.css)(_templateObject(), theme.fontSizes.body2, theme.lineHeights.body2, theme.letterSpacings.body2, isSelectedItem ? 'visible' : 'hidden');
  };
};

exports.menuItem = menuItem;

var icon = function icon(theme) {
  return (0, _react.css)(_templateObject2(), theme.colors.primary.medium);
};

exports.icon = icon;

var select = function select(theme) {
  return (0, _react.css)(_templateObject3(), theme.colors.neutral[600], theme.fontSizes.body2, theme.lineHeights.body2, theme.letterSpacings.body2);
};

exports.select = select;

var basic = function basic(fullWidth, isActive) {
  return function (theme) {
    return (0, _react.css)(_templateObject4(), select(theme), fullWidth ? 'width: 100%' : 'max-width: 148px', theme.colors.white, isActive ? theme.colors.primary.lightest : theme.colors.neutral[400], isActive ? theme.colors.primary.medium : theme.colors.neutral[600], isActive ? 'transparent' : theme.colors.primary.medium, isActive ? theme.colors.primary.lightest : theme.colors.neutral[600], theme.colors.neutral[400], isActive ? theme.colors.primary.medium : theme.colors.neutral[500]);
  };
};

exports.basic = basic;

var ghost = function ghost(fullWidth, isActive) {
  return function (theme) {
    return (0, _react.css)(_templateObject5(), select(theme), fullWidth ? 'width: 100%' : 'max-width: 148px', theme.colors.neutral[600], isActive ? theme.colors.primary.lightest : theme.colors.white, isActive ? 'transparent' : theme.colors.primary.medium, isActive ? 'transparent' : theme.colors.primary.medium, theme.colors.neutral[50], theme.colors.white, isActive ? theme.colors.primary.medium : theme.colors.neutral[500]);
  };
};

exports.ghost = ghost;